export const calculateRewardDetails = (
    matchedItems: any[],
    state: { materialTypes: any[] }
) => {
    if (!matchedItems?.length) return null;

    const rewardAppliedItems = matchedItems.filter(
        (item) => item.rewardDis && item.rewardDis > 0
    );
    if (!rewardAppliedItems.length) return null;

    const distribution: Record<number, { materialTypeName: string; items: Record<string, number> }> = {};
    const materialTypeMap = new Map(
        state.materialTypes?.map(mt => [Number(mt.materialTypeId), mt])
    );

    for (const item of rewardAppliedItems) {
        const matId = Number(item.materialTypeId);
        if (!distribution[matId]) {
            distribution[matId] = {
                materialTypeName: item.materialTypeName || "Unknown",
                items: {},
            };
        }
        distribution[matId].items[item.id] = item.rewardDis;
    }

    const totalRewardRupees = rewardAppliedItems.reduce((sum, item) => {
        const matType = materialTypeMap.get(Number(item.materialTypeId));
        const perRewardPointRs = matType?.perRewardPointRs ?? 1;
        return sum + (item.rewardDis * perRewardPointRs);
    }, 0);

    const materialRedeemPoints: Record<number, number> = {};

    Object.keys(distribution).forEach((matIdStr) => {
        const matId = Number(matIdStr);
        const matType = materialTypeMap.get(matId);
        const perRewardPointRs = matType?.perRewardPointRs ?? 1;

        const totalAmount = Object.values(distribution[matId].items).reduce((sum, amt) => sum + amt, 0);
        materialRedeemPoints[matId] = Math.round(totalAmount / perRewardPointRs);
    });

    const redeemDetails = Object.entries(distribution).map(([matIdStr, dist]) => {
        const matId = Number(matIdStr);
        const matType = materialTypeMap.get(matId);
        const amountConverted = Object.values(dist.items).reduce((a, b) => a + b, 0);

        return {
            id: matType?.id ?? matId,
            materialTypeId: matId,
            materialTypeName: dist.materialTypeName,
            usedPoints: materialRedeemPoints[matId] || 0,
            amountConverted,
            totalAmt: amountConverted,
            rewardPercentage: matType?.maxPercentageOnInvoice || 0,
            isClub: matType?.isClub || false,
        };
    });

    const totalUsedPoints = redeemDetails.reduce(
        (sum, r) => sum + r.usedPoints,
        0
    );

    return {
        distribution,
        materialRedeemPoints,
        totalRewardRupees,
        redeemDetails,
        totalUsedPoints,
    };
};
